import { useState, type ReactNode } from 'react';
import { ChevronRight } from 'lucide-react';
import { cn } from '@/lib/cn';

/**
 * A titled, collapsible group with an item count. Used to group lists (e.g.
 * assets by category). Open by default; state is local per instance.
 */
export function CollapsibleSection({
  title,
  count,
  defaultOpen = true,
  children,
}: {
  title: string;
  count?: number;
  defaultOpen?: boolean;
  children: ReactNode;
}) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
        className="flex w-full items-center gap-2 rounded-md px-1 py-1.5 text-left text-sm font-medium text-[var(--color-foreground)] hover:text-[var(--color-primary)]"
      >
        <ChevronRight className={cn('size-4 shrink-0 text-[var(--color-foreground-muted)] transition-transform', open && 'rotate-90')} />
        <span>{title}</span>
        {count != null ? (
          <span className="inline-flex h-5 min-w-5 items-center justify-center rounded-full bg-[var(--color-surface-muted)] px-1.5 text-[10px] tabular-nums text-[var(--color-foreground-muted)]">
            {count}
          </span>
        ) : null}
      </button>
      {open ? <div className="mt-1.5">{children}</div> : null}
    </div>
  );
}
